//todo: note -- here assuming base BB view proto already extended with mousetrap plugin -- both inherit from */

/* Note: realy just overwriting the following proto method of Marionette with Raphael ... */
/* Note want more for lifecycle -- not using behavior, model and collection events -- breaking w/mousetrap until put into hier (has delegate and undelegate */
/* None of the raphael views are utilizing mousetrap anyway ...*/

//todo: could really just extend from Marionette.Object then (for destroy) and have onRender, afterRender .... and in the shape render, have triggerMethods ... :
// before:destroy, destroy, before:render


var Marionette = require('marionette');
var RaphaelView = require('raphaelView');

/* todo: could normalize all events to jQ event for IE8 centrally */

module.exports = Marionette.ItemView.extend({
    render: Marionette.View.prototype, //(really overwritten now)
   /* render: function() {
        Marionette.View.prototype.render.apply(this, arguments); //not using onRender .... wasn't written for this ...
        this.triggerMethod('afterRender');
        return this;
    },*/
    setElement: function() {
        var ret = RaphaelView.prototype.setElement.apply(this, arguments);
        /* taken direct from Marionette) -- don't need entire -- don't want to inherit from Backbone here */
       // _.invoke(this._behaviors, 'proxyViewProperties', this); /* not doing this */
        return ret;
    },
    delegateEvents: function(events, undelegateEvents) {
        var ret = RaphaelView.prototype.delegateEvents.apply(this, arguments);
        /* not doing this */
      /*  this._delegateDOMEvents(events); --(no UI hash)
        this.bindEntityEvents(this.model, this.getOption('modelEvents'));
        this.bindEntityEvents(this.collection, this.getOption('collectionEvents'));

        _.each(this._behaviors, function(behavior) {
            behavior.bindEntityEvents(this.model, behavior.getOption('modelEvents'));
            behavior.bindEntityEvents(this.collection, behavior.getOption('collectionEvents'));
        }, this);*/
        return ret;

    },

    undelegateEvents: function() {
        var ret =  RaphaelView.prototype.undelegateEvents.apply(this, arguments);

        /* NOT DOING THIS
         this.unbindEntityEvents(this.model, this.getOption('modelEvents'));
         this.unbindEntityEvents(this.collection, this.getOption('collectionEvents'));

         _.each(this._behaviors, function(behavior) {
         behavior.unbindEntityEvents(this.model, behavior.getOption('modelEvents'));
         behavior.unbindEntityEvents(this.collection, behavior.getOption('collectionEvents'));
         }, this);
         */

        return ret;
    },

    /* this allows not to override Item View's render to allow template-less views */
    getTemplate: function() {
        return false;
    }

});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/common/raphaelMarionetteItemView.js
 ** module id = 187
 ** module chunks = 0
 **/